import {
  Component,
  Input,
  OnInit
} from '@angular/core';
import { NGXLogger } from 'ngx-logger';

@Component({
    selector: 'info',
    templateUrl: './info.component.html',
    styleUrls: ['./info.component.css'],
    standalone: false
})
export class InfoComponent implements OnInit {

  @Input()
  public infoText?: any = {
    f1Text: '',
    f2Text: '',
    f3Text: '',
    f4Text: '',
    f5Text: '',
    f6Text: '',
    f7Text: '',
    f8Text: '',
    f9Text: '',
    f10Text: '',
    f11Text: '',
    f12Text: ''
  };

  constructor(
    private logger: NGXLogger
  ) {
    this.logger.log('Info Component');
  }

  public ngOnInit() {
    this.logger.log('init() InfoComponent');
  }

}
